import { Navigate, Route, Routes } from 'react-router-dom'
import VirtualIpAssetDetailPage from './VirtualIpAssetDetailPage'
import VirtualIpAssetListPage from './VirtualIpAssetListPage'
import VirtualIpPositioningApp from './VirtualIpPositioningApp'
import VirtualIpProjectListPage from './VirtualIpProjectListPage'

/** Virtual IP IA shell: Projects + Assets + project-scoped 7-step workflow. */
export default function VirtualIpApp() {
  return (
    <Routes>
      <Route index element={<Navigate to="projects" replace />} />
      <Route path="projects" element={<VirtualIpProjectListPage />} />
      <Route path="projects/:projectId/*" element={<VirtualIpPositioningApp />} />
      <Route path="assets" element={<VirtualIpAssetListPage />} />
      <Route path="assets/:assetId" element={<VirtualIpAssetDetailPage />} />
      <Route path="*" element={<Navigate to="projects" replace />} />
    </Routes>
  )
}
